// Intentionally global
___export = require('./../../lib/src-server/azure-server').setDirName(__dirname).serve(require('./../../lib/src-server/example-function-class').main);
module.exports = ___export;


//////////////////
// WEBPACK FOOTER
// ./deployment/example-function-class/build.source.js
// module id = 275
// module chunks = 13